export const siteData = {
  name: 'Simeon Leatherland',
  contact: {
    email: 'hello@simeonleatherland.com',
    instagram: 'https://www.instagram.com/simeonleatherland/',
    linkedin: 'https://www.linkedin.com/in/simeonleatherland/',
  },
  location: 'Sydney',
  year: new Date().getFullYear(),
};

export const navItems = [
  {
    id: 1,
    label: 'music',
    slug: 'music',
    preview: 'DJ sets, radio & events',
    type: 'music',
    subItems: [
      {
        slug: 'disc-jockey',
        label: 'disc jockey',
        type: 'gallery',
        heading: 'Sim Select',
        soundcloud: 'https://soundcloud.com/sim-select',
        ra: 'https://ra.co/dj/simselect/past-events?page=2',
        instagram: 'https://www.instagram.com/sim___select/',
        description:
          'Eora-based DJ, producer, and host of Drum Workout on Area 3000 Radio. A dynamic selector with a love for unique club sounds, often leaning into functional percussive tracks with bouncy basslines and unique textures. Expect a journey through a new wave of genre-blending club music — from dancehall and house to techno and bass — with dance-floor pace and sound systems in mind.',
        supports: [
          'Ben UFO',
          'Interplanetary Criminal',
          'Roza Terenzi',
          'Moktar',
          'Chloé Robinson',
          'Jay Carder',
          'Baraka',
          'DJ Sweet6teen',
          'Eastern Distributor',
        ],
        notableShows: [
          'Lost Paradise (2024 / 2025)',
          'Twominds Festival — Christchurch, NZ',
          'Sim Select All Night Long — Chinese Laundry, Sydney',
        ],
        gigs: [
          { date: '05.04.26', event: 'Lost Sundays Block Party', venue: 'The Ivy, Sydney' },
          {
            date: '24.01.26',
            event: 'Parallel Presents: Cousin',
            venue: 'Slipway at Mothership Studios, Sydney',
          },
          { date: '28.12.25', event: 'Lost Paradise 2025', venue: 'Glenworth Valley, Sydney' },
          {
            date: '14.11.25',
            event: 'Chinese Laundry Invites FAFI ABDUL NOUR & dj sweet6teen',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '27.09.25',
            event: 'Chinese Laundry Residents Curate',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '02.08.25',
            event: 'Chinese Laundry Residents Night',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '05.07.25',
            event: 'APOLETT + Sim Select at Glamorama Saturdays',
            venue: 'Glamorama, Melbourne',
          },
          { date: '05.07.25', event: 'Bouki & Friends', venue: 'Section 8, Melbourne' },
          {
            date: '08.06.25',
            event: 'Lost Sundays Block Party — June Long Weekend',
            venue: 'The Ivy, Sydney',
          },
          {
            date: '23.05.25',
            event: 'Chinese Laundry Invites ATARANGI + Friends',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '25.04.25',
            event: 'Chinese Laundry Invites DRUM WORKOUT [Full Venue Takeover]',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '17.01.25',
            event: 'Chinese Laundry Invites DRUM WORKOUT',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '12.01.25',
            event: 'Lost Sundays XXL w. Interplanetary Criminal + Ben UFO',
            venue: 'The Ivy, Sydney',
          },
          {
            date: '11.01.25',
            event: 'Bouki presents Oldboy, LMajor, Jay Carder [UK]',
            venue: 'Inner West, Sydney',
          },
          { date: '28.12.24', event: 'Lost Paradise 2024', venue: 'Glenworth Valley, Sydney' },
          {
            date: '15.12.24',
            event: 'Drum Workout: Secret Guest [UK]',
            venue: "Cafe Freda's, Sydney",
          },
          { date: '14.12.24', event: 'Gems and Jams', venue: 'Odd Assembly, Sydney' },
          { date: '21.11.24', event: 'CNC offline', venue: 'Civic Underground, Sydney' },
          {
            date: '07.09.24',
            event: 'Lost Sundays w. Soul Mass Transit System',
            venue: 'The Ivy, Sydney',
          },
          {
            date: '09.08.24',
            event: 'Chinese Laundry Invites Bouki — Ben Fester + Cousin',
            venue: 'Chinese Laundry, Sydney',
          },
          {
            date: '03.08.24',
            event: 'CLUB Ctrl pres. Little Fritter',
            venue: 'Abercrombie Hotel, Sydney',
          },
          {
            date: '20.07.24',
            event: 'UNDISCLOSED 55.0 with dj pgz',
            venue: 'Abercrombie Hotel, Sydney',
          },
          { date: '13.07.24', event: 'Parallel pres. Caucasian Opportunities', venue: 'Sydney' },
          { date: '10.05.24', event: 'Maze Manor x Debaser', venue: 'The Lord Gladstone, Sydney' },
          {
            date: '07.04.24',
            event: 'Lost Sundays w. Willaris. K & Chloé Robinson',
            venue: 'The Ivy, Sydney',
          },
          {
            date: '22.03.24',
            event: 'KNC. 020 with Cromby, dameeeela, dj pgz',
            venue: 'Civic Underground, Sydney',
          },
          {
            date: '15.03.24',
            event: 'Twominds Festival',
            venue: 'Spencer Beach Holiday Park, Christchurch',
          },
          {
            date: '16.02.24',
            event: 'Parallel pres. Golden Hour',
            venue: 'The Metro Theatre, Sydney',
          },
          {
            date: '24.12.23',
            event: 'UNDISCLOSED 49.0 with Eastern Distributor and Tangela',
            venue: 'Abercrombie Hotel, Sydney',
          },
          { date: '10.12.23', event: 'Lost Sundays w. Young Marco', venue: 'The Ivy, Sydney' },
          {
            date: '11.11.23',
            event: 'Plastic Ego presents: PANIC ROOM',
            venue: 'Goodwill Club, Perth',
          },
          {
            date: '24.09.23',
            event: 'Lost Sundays w. Barney Kato, Caitlin Medcalf & Mincy',
            venue: 'The Ivy, Sydney',
          },
        ],
        heroImage: {
          image: '/dj/dj-01.jpg',
          artist: 'Lost Paradise 2024',
          title: 'Glenworth Valley, Sydney',
          date: '28.12.24',
        },
        leftColumn: [
          {
            image: '/dj/dj-02.jpg',
            imgClass: 'pf-img--portrait',
            artist: 'Lost Sundays Block Party',
            title: 'The Ivy, Sydney',
            date: '07.09.24',
            meta: 'b2b Bouki',
            caption: null,
          },
        ],
        rightColumn: [
          {
            image: '/dj/dj-04.jpg',
            imgClass: 'pf-img--portrait',
            artist: 'Lost Sundays Block Party',
            title: 'The Ivy, Sydney',
            date: '05.04.26',
            caption: null,
          },
        ],
      },
      {
        slug: 'radio',
        label: 'radio',
        type: 'gallery',
        squareImages: true,
        heading: 'Drum Workout',
        soundcloud: 'https://soundcloud.com/sim-select/sets/drum-workout-area3000',
        instagram: 'https://www.instagram.com/drum___workout/',
        description:
          'Lots of drums, lots of bass — a fortnightly show on Area 3000 Radio hosted by Sim Select, featuring underground artists from across the globe.',
        leftColumn: [
          {
            image: '/radio/ep01-burna.jpg',
            artist: 'Episode 1 — Burna',
            title: 'Perth, WA',
            date: '05.03.24',
            meta: 'Area 3000 Radio',
            caption:
              'Perth based producer/DJ. Blending UK Funky, Grime, Baile Funk, Jungle and everything in between — his tunes have featured in mixes for Boiler Room, Keep Hush and Rinse FM.',
          },
          {
            image: '/radio/ep03-longeez.jpg',
            artist: 'Episode 3 — Longeez',
            title: 'Bristol, UK',
            date: '09.05.24',
            meta: 'Area 3000 Radio',
            caption:
              'Bristol born producer/DJ and SWU FM resident. Initially getting his name out through garage and breaks, now transitioning into hard house and techno with his standout EP DW-01 on Hardline.',
          },
          {
            image: '/radio/ep05-prizefight.jpg',
            artist: 'Episode 5 — Prizefight',
            title: 'Naarm / Melbourne',
            date: '24.07.24',
            meta: 'Area 3000 Radio',
            caption:
              'Melbourne based producer drawing from house, garage and jungle with a common theme of "anything with a fat bass line". A mix of lower bpm, left field bass music.',
          },
          {
            image: '/radio/ep07-dayzzi.jpg',
            artist: 'Episode 7 — Dayzzi',
            title: 'Eora / Sydney',
            date: '03.09.24',
            meta: 'Area 3000 Radio',
            caption:
              'An artist who effortlessly weaves intricate rhythmic patterns with heavy percussion into her sets. Rooted in baile funk, miami bass, breaks, dembow and tribal techno. Influenced by TSVI, INVT, and Amor Satyr.',
          },
          {
            image: '/radio/ep09-dyslecta.jpg',
            artist: 'Episode 9 — Dyslecta',
            title: 'Yorkshire / London',
            date: '11.11.24',
            meta: 'Area 3000 Radio',
            caption:
              'Yorkshire-born, London-based DJ and producer. Releases on Earful of Wax, APE-X and Out Of Sorts. Gigs at The Pickle Factory, The Cause and a debut at Tresor, Berlin.',
          },
          {
            image: '/radio/ep11-attu.jpg',
            imgClass: 'pf-img--natural',
            artist: 'Episode 11 — ATTU',
            title: 'Eora / Sydney',
            date: '20.03.25',
            meta: 'Area 3000 Radio',
            caption:
              'An emerging force in the Eora music scene, redefining the boundaries of sound. Seamlessly weaving Afro and tribal rhythms, vogue, drum and bass, hip hop, electronica and techno.',
          },
          {
            image: '/radio/ep13-pino-pena.jpg',
            imgClass: 'pf-img--natural',
            artist: 'Episode 13 — Pino Peña',
            title: 'Berlin',
            date: '30.06.25',
            meta: 'Area 3000 Radio',
            caption:
              'Head of forward-thinking label W133 and resident at Schimmer Records. His sets dive into techno, house, breaks and everything in between — with nods to punk, jazz, hip-hop and psych rock.',
          },
        ],
        rightColumn: [
          {
            image: '/radio/ep02-miss-behave.jpg',
            artist: 'Episode 2 — Miss Behave',
            title: 'Eora / Sydney',
            date: '03.04.24',
            meta: 'Area 3000 Radio',
            caption:
              "An extremely talented selector known for breaky, psychedelic, electro sounds. Has played across Break and Outsider festivals and is a regular fixture in Eora's underground scene.",
          },
          {
            image: '/radio/ep04-dual-monitor.jpg',
            artist: 'Episode 4 — Dual Monitor',
            title: 'Liverpool / Bristol',
            date: '05.06.24',
            meta: 'Area 3000 Radio',
            caption:
              'A production & DJ duo with a meteoric rise in 2023 via a breakout Boiler Room Liverpool set. Releases on Cloudcore, EC2a, Amity and Hardline. Sets spanning UK funky, speed dembow and techno.',
          },
          {
            image: '/radio/ep06-atarangi.jpg',
            artist: 'Episode 6 — Atarangi',
            title: 'Naarm / Melbourne',
            date: '16.08.24',
            meta: 'Area 3000 Radio',
            caption:
              'Birthed through the ecosystem of ballroom, drawing heavy influence from the queer underground. Shared stages with LSDXOXO, Overmono, Nia Archives, Tim Reaper and HorsegiirL.',
          },
          {
            image: '/radio/ep08-miles-amillion.jpg',
            artist: 'Episode 8 — Miles Amillion',
            title: 'Miami, FL',
            date: '08.10.24',
            meta: 'Area 3000 Radio',
            caption:
              'Miami-based producer with 13 years of experience bending and transforming between soundscapes — from hip-hop sampling to ambient electronic music and beyond.',
          },
          {
            image: '/radio/ep10-elbarto.jpg',
            artist: 'Episode 10 — Elbarto',
            title: 'Boorloo / Perth',
            date: '10.12.24',
            meta: 'Area 3000 Radio',
            caption:
              'Greek/Australian producer and DJ rooted in bass culture. Genre-fluid sets traverse dubstep, breakbeat, UK funky and techno. Releases on EC2A, Taipan Trax, Red Line and Big Ting.',
          },
          {
            image: '/radio/ep12-dj-jm.jpg',
            imgClass: 'pf-img--natural',
            artist: 'Episode 12 — DJ JM',
            title: 'Vilnius / London',
            date: '16.05.25',
            meta: 'Area 3000 Radio',
            caption:
              'Originally from Vilnius, Lithuania, based in London. Known for rhythmically complex, sample-heavy tracks. Releases on Nervous Horizon, Even The Strong, Goon Club Allstars and Maloca Records.',
          },
        ],
      },
      {
        slug: 'events',
        label: 'events',
        type: 'gallery',
        squareImages: true,
        heading: 'Drum Workout',
        description:
          'Drum Workout makes its club debut, spotlighting cutting-edge, bass-oriented club music. Starting as a radio show on Area3000 in Naarm, Drum Workout is hosted by Sim Select and champions forward-thinking artists redefining the dancefloor experience.',
        leftColumn: [
          {
            image: '/events/chinese-laundry-apr-25.jpg',
            imgClass: 'pf-img--four-five',
            artist: 'Drum Workout — Full Venue Takeover',
            title: 'Chinese Laundry, Sydney',
            date: '25.04.25',
            meta: 'Sim Select All Night Long / Pixelchick, Missbehave, Speng',
            caption: null,
          },
          {
            image: '/events/chinese-laundry-sep-25.jpg',
            imgClass: 'pf-img--four-five',
            artist: 'Drum Workout + Bouki',
            title: 'Chinese Laundry, Sydney',
            date: '27.09.25',
            meta: 'Mash, Bouki, Sim Select, OHMS, Cricket, Vern',
            caption: null,
          },
          {
            image: '/events/cafe-fredas-dec-24.jpg',
            artist: 'Drum Workout — Thank You Party',
            title: "Cafe Freda's, Sydney",
            date: '15.12.24',
            meta: 'Miss Behave, eggplant3, Sim Select + Secret Guest [UK]',
            caption: null,
          },
        ],
        rightColumn: [
          {
            image: '/events/chinese-laundry-nov-25.jpg',
            imgClass: 'pf-img--four-five',
            artist: 'Drum Workout + Bouki feat. Holloway [UK]',
            title: 'Chinese Laundry, Sydney',
            date: '01.11.25',
            meta: 'Holloway [UK], Bouki, CH_L_OE, Lily FM, Speng',
            caption: null,
          },
          {
            image: '/events/hope-st-radio-oct-24.jpg',
            artist: 'Drum Workout on Hope St Radio',
            title: 'Hope St Radio',
            date: '11.10.24',
            meta: 'Sim Select, 7–9PM',
            caption: null,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: 'tech',
    slug: 'tech',
    preview: 'Software & development work',
    type: 'cv',
    sections: [],
  },
  {
    id: 3,
    label: 'about me',
    slug: 'about',
    preview: 'Who I am',
    type: 'gallery',
    heading: 'About Me',
    email: 'simeon.leatherland@gmail.com',
    phone: '0408765902',
    instagram: 'https://www.instagram.com/sim___select/',
    description:
      'Software engineer with a love for building things, and an equal passion for music. That passion has taken shape as Sim Select — playing clubs and festivals across Australia and New Zealand — and Drum Workout, a fortnightly radio show on Area 3000 championing underground artists from across the globe.',
    sections: [
      {
        heading: 'Employment',
        entries: [
          {
            role: 'Senior Software Engineer',
            org: 'Atlassian — Automation for Jira, Sydney',
            date: '2021–2026',
            tech: 'Java · Spring Boot · TypeScript · React · REST · GraphQL · PostgreSQL · AWS',
          },
          {
            role: 'Full Stack Software Developer',
            org: 'VGW — Global Poker, Perth',
            date: '2019–2021',
            tech: 'Java · TypeScript · React · GatsbyJS · GraphQL · Docker · AWS',
          },
        ],
      },
      {
        heading: 'Education',
        entries: [
          {
            role: 'B.S. Software Engineering',
            org: 'Curtin University, Perth',
            date: '2017–2020',
          },
        ],
      },
    ],
  },
];
